export default __webpack_public_path__ + "static/media/102.afee2a4b.jpg";